// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V22H22V2ZM4 14V4H20V14H4ZM8.00195 16.998V19.002H5.99805V16.998H8.00195ZM11.002 16.998V19.002H8.99805V16.998H11.002Z"}}]};

const HardDriveFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'hard-drive-filled',
    ref,
    icon: element,
  },
));

HardDriveFilledIcon.displayName = 'HardDriveFilledIcon';

export default HardDriveFilledIcon;
